import { Typography } from 'fronton-react';
import React from 'react';
import { OptionType } from 'data/types';
import { cardStyles } from './styles';

interface CardProps extends OptionType {
	mobile: boolean;
}
export const Card = ({ src, img, text, mobile }: CardProps) => (
	<div className={cardStyles} data-qa="option-card">
		<a href={src} target="_blank" role="link">
			<img src={img} />
		</a>
		<Typography variant={mobile ? 's' : 'm'} size="subtitle">
			{text}
		</Typography>
	</div>
);
